module.exports = __webpack_public_path__ + "static/banner-dna-3a50963733cabc19693a1d72570915a0.png";